var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"m-0"},[_vm._v(" 抱歉， 页面正在开发中... 点击跳转到 "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.goHome}},[_vm._v("首页")])])])}
var staticRenderFns = []

export { render, staticRenderFns }